import GenericDB from './generic-db';

export default class AuthorizationsDB extends GenericDB {
  constructor() {
    super('authorizations');
  }
}
